import React from 'react';

import { Container, Label, StyledLink } from '../InformationBlocks.styled';

export interface Props {
    points: string;
}

const UCASPoints: React.FC<Props> = props => {
    const { points } = props;

    return (
        <Container>
            <Label>
                UCAS points: <strong>{points}</strong>
            </Label>
            <StyledLink
                label="Flexible entry options available"
                href="/how-to-apply/undergraduate-applications/contextual-offers"
                ariaLabel="Click for more information on contextual offers"
            />
        </Container>
    );
};

export default UCASPoints;
